class MainComponent {
	/**
	 * Initialize all functionality of MainComponent.
	 */
	init(): void {
		this.siteSearchSettings();
		this.copyright();
		this.contactLink();
	}

	/**
	 * Configure site search settings.
	 */
	private siteSearchSettings(): void {
		const searchCss = document.createElement("link");
		const searchScript = document.createElement("script");

		// Configure CSS for search
		searchCss.href = "https://ce.mf.marsflag.com/latest/css/mf-search.css";
		searchCss.rel = "stylesheet";
		searchCss.type = "text/css";
		searchCss.media = "all";
		searchCss.charset = "UTF-8";
		document.head.appendChild(searchCss);

		// Configure and append search script if body ID is not 'mf_Result'
		if ($("body").attr("id") !== "mf_Result") {
			interface GALFSRAM {
				mfx?: {
					routerMode?: string;
				};
			}

			interface Window {
				GALFSRAM?: GALFSRAM;
			}

			const G: GALFSRAM = (window.GALFSRAM = window.GALFSRAM || {});
			G.mfx = G.mfx || {};
			G.mfx.routerMode = "history";
			searchScript.src = "https://ce.mf.marsflag.com/latest/js/mf-search.js";
			searchScript.charset = "UTF-8";
			document.body.appendChild(searchScript);
		}
	}

	/**
	 * Update copyright year dynamically.
	 */
	private copyright(): void {
		const $copy = $("#js_copyright");
		const tDate = new Date();
		const tYear = `Copyright &copy; ${tDate.getFullYear()} TORAY INDUSTRIES, INC.`;
		$copy.html(tYear);
	}

	/**
	 * Add click event for elements with the class `js_contactLink`
	 * to open a new tab with a modified URL.
	 */
	private contactLink(): void {
		// Find all elements with the `js_contactLink` class
		$(".js_contactLink").on("click", function (event) {
			event.preventDefault(); // Prevent the default action of the anchor tag
			const href = $(this).attr("href"); // Get the href attribute of the element
			const currentUrl = window.location.href; // Get the current page URL

			if (href) {
				// Append the current URL as the `s` query parameter
				const modifiedUrl = `${href}?s=${encodeURI(currentUrl)}`;
				// Open the modified URL in a new tab
				window.open(modifiedUrl, "_blank");
			}
		});
	}
}

export default new MainComponent();
